import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {
  unsubscribeForm!: FormGroup;
  listaDestinatariosId: string = '';
  tenantId: string = '';
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  errorMessage: string = '';
  private apiUrl = environment.apiUrl;

  // Mapeamento dos valores para os textos das opções
  private motivoTextos: { [key: string]: string } = {
    'frequencia': 'Recebo emails com muita frequência',
    'relevancia': 'O conteúdo não é relevante para mim',
    'repetitivo': 'O conteúdo é repetitivo',
    'outro': 'Outro motivo'
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.unsubscribeForm = this.fb.group({
      motivo: ['', [Validators.required]],
      outroMotivo: ['']
    });
  }

  ngOnInit(): void {
    // Obter os GUIDs da URL como parâmetros de rota
    // listaDestinatariosId = ID da lista de destinatários
    // tenantId = ID do tenant
    this.listaDestinatariosId = this.route.snapshot.paramMap.get('listaDestinatariosId') || '';
    this.tenantId = this.route.snapshot.paramMap.get('tenantId') || '';

    // Validar se os GUIDs foram fornecidos
    if (!this.listaDestinatariosId || !this.tenantId) {
      this.isError = true;
      this.errorMessage = 'Link inválido. Por favor, use o link fornecido no email.';
    }

    // Validar campo "outroMotivo" quando "Outro motivo" for selecionado
    this.unsubscribeForm.get('motivo')?.valueChanges.subscribe((motivo) => {
      if (motivo === 'outro') {
        this.unsubscribeForm.get('outroMotivo')?.setValidators([Validators.required]);
      } else {
        this.unsubscribeForm.get('outroMotivo')?.clearValidators();
        this.unsubscribeForm.get('outroMotivo')?.setValue('');
      }
      this.unsubscribeForm.get('outroMotivo')?.updateValueAndValidity();
    });
  }

  private enviarUnsubscribe(motivo: string, onSuccess?: () => void, onError?: (error: any) => void): void {
    // Validar se os GUIDs foram fornecidos
    if (!this.listaDestinatariosId || !this.tenantId) {
      if (onError) {
        onError(new Error('GUIDs inválidos'));
      }
      return;
    }

    // Determinar a mensagem baseada no motivo selecionado
    let mensagem = this.motivoTextos[motivo] || motivo;
    
    // Se for "outro", usar o texto do campo outroMotivo quando disponível
    if (motivo === 'outro') {
      const outroMotivo = this.unsubscribeForm.get('outroMotivo')?.value;
      if (outroMotivo && outroMotivo.trim() !== '') {
        mensagem = outroMotivo;
      }
    }

    // Preparar payload
    const payload = {
      listaDestinatarioId: this.listaDestinatariosId,
      tenantId: this.tenantId,
      mensagem: mensagem
    };

    // Fazer POST para a API
    this.http.post(`${this.apiUrl}/v1/Emailmarketing/webhook/unsubscribe`, payload)
      .subscribe({
        next: () => {
          console.log('Unsubscribe enviado com sucesso');
          if (onSuccess) {
            onSuccess();
          }
        },
        error: (error) => {
          console.error('Erro ao enviar unsubscribe:', error);
          if (onError) {
            onError(error);
          }
        }
      });
  }

  onSubmit(): void {
    if (this.unsubscribeForm.invalid) {
      this.unsubscribeForm.markAllAsTouched();
      return;
    }

    if (!this.listaDestinatariosId || !this.tenantId) {
      this.isError = true;
      this.errorMessage = 'Link inválido. Por favor, use o link fornecido no email.';
      return;
    }

    this.isLoading = true;
    this.isError = false;
    this.isSuccess = false;

    const formValue = this.unsubscribeForm.value;
    const motivo = formValue.motivo;

    // Enviar POST quando o botão for clicado
    this.enviarUnsubscribe(motivo, () => {
      // Callback de sucesso
      this.isLoading = false;
      this.isSuccess = true;
    }, (error) => {
      // Callback de erro
      this.isLoading = false;
      this.isError = true;
      this.errorMessage = 'Erro ao processar solicitação. Tente novamente.';
    });
  }
}

